import { exec } from "jadelet"
export default exec(["loader",{},[["p",{},[{"bind":"message"}]],["progress",{"class":[{"bind":"class"}],"value":{"bind":"value"},"max":{"bind":"max"}},[]]]])